import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackSearchInteraction = (data: Data) => {
  if (data.sportCode) {
    data.sportCode = formatSportNameForAnalytics(data.sportCode)
  }
  trackEvent(keys.searchInteraction, { ...defaultAnalyticsData, ...data })
}

export const trackSearch = (data: Data) => {
  if (data.sportCode) {
    data.sportCode = formatSportNameForAnalytics(data.sportCode)
  }
  trackEvent(keys.search, { ...defaultAnalyticsData, ...data })
}

function formatSportNameForAnalytics(str: string) {
  return str
    .toLowerCase()
    .replace(/_([a-z])/g, g => (g ? ' ' + g[1].toUpperCase() : ''))
    .replace(/^[a-z]/, g => g.toUpperCase())
}

// =============
// Local Helpers
// =============

const defaultAnalyticsData: Record<keyof SearchEventData, undefined> = {
  interaction_type: undefined,
  search_term: undefined,
  searchOrigin: undefined,
  resultsFound: undefined,
  raceStatus: undefined,
  resultType: undefined,
  raceCode: undefined,
  sportCode: undefined,
  competition: undefined,
}

// =====
// Types
// =====

type Interaction =
  | 'Search Opened'
  | 'Search Results Viewed'
  | 'Search Result Clicked'
  | 'Search Cleared'
  | 'Search Closed'

type SearchEventData = {
  interaction_type: Interaction
  search_term: string
  searchOrigin: string
  resultsFound: boolean
  raceStatus: string
  resultType: string
  raceCode: string
  sportCode: string
  competition: string
}

type Data = Partial<SearchEventData> & {
  interaction_type: Interaction
}
